import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Từ thời gian: ", -1)
const _hoisted_8 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Đến thời gian: ", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"13px","font-style":"oblique","font-weight":"bold"} }, "Số tồn cũ = Số tồn đầu + Số nhập - Số cấp - Số hủy", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_16 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "BÁO CÁO TÌNH HÌNH SỬ DỤNG VẮC XIN VÀ DỤNG CỤ TIÊM CHỦNG" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Panel, { header: "Thời gian báo cáo" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_Calendar, {
                          modelValue: $setup.baoCao.tuNgay,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.tuNgay) = $event)),
                          touchUI: "",
                          view: "date",
                          dateFormat: "dd/mm/yy"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_Calendar, {
                          modelValue: $setup.baoCao.denNgay,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCao.denNgay) = $event)),
                          touchUI: "",
                          view: "date",
                          dateFormat: "dd/mm/yy"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_DataTable, {
                value: $setup.baoCao.baoCaos,
                showGridlines: "",
                rows: 40,
                rowHover: true,
                style: {"font-size":"14px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ColumnGroup, { type: "header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "TT",
                            rowspan: 3,
                            style: {"width":"5px"}
                          }),
                          _createVNode(_component_Column, {
                            header: "Lọai vắc xin vật tư tiêm chủng",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Số đối tượng được tiêm",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Số tồn cũ (liều, cái)\t",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Số nhận mới (liều, cái)",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Số cấp phát (liều, cái)",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Số sử dụng (tính theo liều các lọ đã mở)",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Hệ số sử dụng",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Số hủy (số liều hủy nguyên lọ vắc xin)",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Số hiện còn (liều, cái)",
                            colspan: 4
                          }),
                          _createVNode(_component_Column, {
                            header: "Số hiện còn sử dụng mấy tháng",
                            rowspan: 3
                          }),
                          _createVNode(_component_Column, {
                            header: "Ghi chú",
                            rowspan: 3
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Của đơn vị",
                            rowspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Của tuyến dưới",
                            rowspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Tại kho đơn vị",
                            rowspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Tại tuyến dưới",
                            rowspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Tại kho đơn vị",
                            colspan: 2
                          }),
                          _createVNode(_component_Column, {
                            header: "Tuyến dưới",
                            colspan: 2
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Số lượng",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Hạn dùng gần nhất",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Số lượng",
                            colspan: 1
                          }),
                          _createVNode(_component_Column, {
                            header: "Hạn dùng gần nhất",
                            colspan: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "",
                    style: {"width":"5px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSo",
                    header: "Tổng số"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("label", null, _toDisplayString(slotProps.data.loaiVacxin), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soTrucThuoc",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soDoiTuongDuocTiem,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soDoiTuongDuocTiem) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "soCSCoYeuToCoHai",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.donVi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.donVi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.tuyenDuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.tuyenDuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soNhanMoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soNhanMoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soCapPhat,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soCapPhat) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongNuCoSoCoYeuTo",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soSuDung,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soSuDung) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.heSoSuDung,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.heSoSuDung) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.taiKhoDonVi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiKhoDonVi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.taiTuyen,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.taiTuyen) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soLuongDonVi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongDonVi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: "",
                    style: {"width":"100px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Calendar, {
                        modelValue: slotProps.data.hanDungGanNhatDonVi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.hanDungGanNhatDonVi) = $event),
                        touchUI: "",
                        view: "date",
                        dateFormat: "dd/mm/yy"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soLuongTuyenDuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongTuyenDuoi) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: "",
                    style: {"width":"100px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Calendar, {
                        modelValue: slotProps.data.hanDungGanNhatTuyenDuoi,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.hanDungGanNhatTuyenDuoi) = $event),
                        touchUI: "",
                        view: "date",
                        dateFormat: "dd/mm/yy"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputNumber, {
                        inputId: "integeronly",
                        modelValue: slotProps.data.soHienConSuDung,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.soHienConSuDung) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "tongSoLDTiepXucTrucTiep",
                    header: "",
                    style: {"width":"250px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_InputText, {
                        id: "username",
                        type: "text",
                        modelValue: slotProps.data.ghiChu,
                        "onUpdate:modelValue": ($event: any) => ((slotProps.data.ghiChu) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                label: "Gởi báo cáo",
                icon: "pi pi-upload",
                severity: "secondary",
                raised: "",
                onClick: $setup.addReport
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}